import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WarehousingAbnormalService {

  constructor(
    private http: HttpClient
  ) { }

  searchWarehousingAbnormal(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/search/searchWarehousingAbnormal`;
    return this.http.post(url, params);
  }

  searchWarehousingAbnormalHistory(whNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/search/searchWarehousingAbnormal/${whNo}`;
    return this.http.get(url);
  }

  searchWarehousingAbnormalHeader(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/search/searchWarehousingAbnormalHeaderAndDetails`;
    return this.http.post(url, params);
  }

  searchWarehousingAdHeader(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/search/searchAdHeaderAndDetails`;
    return this.http.post(url, params);
  }

  validateBeforeExecution(whNo: string, userId: string, abnormalType: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/validateBeforeExecution?whNo=${whNo}&userId=${userId}&abnormalType=${abnormalType}`;
    return this.http.post(url, null);
  }

  submitHandleCase(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/warehousingAbnormalHeader?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

  importWarehousingDetailAndUpdateWarehousingAbnormal(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/importWarehousingDetailAndUpdateWarehousingAbnormal?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

  submitHaupdateWarehousingAbnormalAndStatusByShippingImportedAdFinishndleCase(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/updateWarehousingAbnormalAndStatusByShippingImportedAdFinish?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

  updateWarehousingAbnormalAndStatusByPcsrWriteAdCannotBeImportedReason(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/updateWarehousingAbnormalAndStatusByPcsrWriteAdCannotBeImportedReason?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

  updateWarehousingAbnormalAndStatusByShippingContinuesToTrackTheAbnormalCase(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/updateWarehousingAbnormalAndStatusByShippingContinuesToTrackTheAbnormalCase?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

  updateWarehousingAbnormalAndStatusByPcsrImportedAdToFinish(params: any, handleCase: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousingAbnormal/update/updateWarehousingAbnormalAndStatusByPcsrImportedAdToFinish?handleCase=${handleCase}`;
    return this.http.post(url, params);
  }

}
